<template>
    <div v-if="options_loaded && passed_filter && panel_required">
        <div :data-designer-component-id="component_id" class="designeroption">
            <h3 v-if="maintitle != ''">
                {{ maintitle }}
            </h3>
            <div class="stylesoption">
                <div class="form-group" :class="[!valid_selection ? 'has-error' : '']">
                    <label :for="'question--' + component_id">{{ title }}</label>
                    <select :id="'question--' + component_id" class="form-control" v-model="localTarget" v-if="!loading">
                        <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                    </select>
                    <select :id="'question--' + component_id" disabled class="form-control" v-if="loading">
                        <option>Loading Options...</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>
